export default {"src":"/_next/static/media/Equipment.52426a84.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};